/**
 * Shared link builder (kept out of `pages/home/pages` barrel so blocks/layout code
 * does not eagerly pull every tab page into the main chunk).
 */
export function generateSideSwapTradingLink(
  project,
  quote = '6f0279e9ed041c3d710a9f57d0c02928416460c4b722ae3457a11eec381c526d',
) {
  const { secondaryAssetId } = project
  return `https://sideswap.io/swap-market/?base=${secondaryAssetId}&quote=${quote}`
}
